import { render } from "./ResourcePopup.vue?vue&type=template&id=7ac24e28&scoped=true&ts=true"
import script from "./ResourcePopup.vue?vue&type=script&lang=ts"
export * from "./ResourcePopup.vue?vue&type=script&lang=ts"

import "./ResourcePopup.vue?vue&type=style&index=0&id=7ac24e28&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac24e28"]])

export default __exports__